import React from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import { BreadcrumbComponent } from "../../../common/components";
import { breadcrumbLinkSocialImport } from "../customer-list.constant";
import FacebookIcon from "../../../assets/icons/facebook.svg";
import LinkedInIcon from "../../../assets/icons/linkedin.svg";
import ArrowUpLine from "../../../assets/icons/arrow-up-line.svg";
import "./social-import.scss";

const socialPlatforms = [
  {
    name: "Facebook Ads Sync",
    description: "Sync leads from your Facebook platform to AFP CRM using",
    icon: <img src={FacebookIcon} className="facebook-icon" />,
  },
  {
    name: "LinkedIn Ads Sync",
    description: "Sync leads from your LinkedIn platform to AFP CRM using",
    icon: <img src={LinkedInIcon} className="linkedin-icon" />,
  },
];

const SocialImport: React.FC = () => {
  return (
    <div>
      <div className="breadcrumb-wrapper">
        <BreadcrumbComponent breadcrumbLink={breadcrumbLinkSocialImport()} showBackArrow={true} />
      </div>
      <Box className="social-import-wrapper">
        <Typography variant="h5" className="social-import-title">
          Choose your favourite social media platforms to import data seamlessly.
        </Typography>
        <Typography variant="body1" className="social-import-subtitle">
          Connect your accounts and effortlessly manage leads and customer details with just a few clicks!
        </Typography>

        <Box className="social-import-card-group">
          {socialPlatforms.map((platform, index) => (
            <Card key={index} className="social-import-card">
              <div className="social-import-icon">{platform.icon}</div>
              <CardContent className="social-import-content">
                <Typography variant="h6" className="social-import-header">
                  {platform.name}
                </Typography>
                <Typography variant="body2" className="social-import-description">
                  {platform.description}
                </Typography>
                <Button variant="text" className="setup-button">
                  Setup now <img src={ArrowUpLine} />
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default SocialImport;